import { gdSlsReportError } from "@/utils/gdSlsRum";
import initUdesk from "@/utils/initUdesk";
import React from "react";
import HBEmpty from "../HBEmpty";
import styles from "./index.module.less";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);

    // Define a state variable to track whether is an error or not
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    // 更新 state，下次渲染可以展示错误相关的 UI
    return { hasError: true, error: error };
  }
  componentDidCatch(error) {
    // You can use your own error logging service here
    // console.log(error, errorInfo);
    // 错误上报
    gdSlsReportError(error);
  }

  refreshPage() {
    window.location.reload();
  }

  contactKefu() {
    initUdesk(null, () => {
      window.ud && window.ud.showPanel();
    });
  }

  render() {
    // Check if the error is thrown
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div>
          <div
            className={styles.errPage}
            data-gd-expose="dialog_expose"
            data-dialog-title="500页面错误"
          >
            <HBEmpty
              image="//st0.dancf.com/static/02/202306251114-0795.png"
              title="Oh~抱歉，访问的页面出错了"
              subtitle="请检查您访问的地址是否正确，或者返回首页"
            />
            <div className={styles.link}>
              <a href="/discovery">返回发现页</a>
              <span>|</span>
              <a onClick={this.refreshPage}>刷新页面</a>
              <span>|</span>
              <a onClick={this.contactKefu}>联系客服</a>
            </div>
          </div>
        </div>
      );
    }

    // Return children components in case of no error
    return this.props.children;
  }
}
